import * as ol from "openlayers";
import BasePointAspect from "./BasePointAspect";
import { translate } from "@/translation/native_translate.js";

export default class IncidentAspect extends BasePointAspect {
  constructor(data) {
    super(data);
    //must match dss object type
    this.setProperties(data);
    this.setZIndex(50);
  }

  setProperties(data) {
    super.setProperties(data);
    this.set("type", "Incident");
    this.set("rightClickSetting", "IncidentManagerForm");
    this.set("date", Number(data.dataFieldTable.dateTime) * 1000);
    this.set("description", data.dataFieldTable.description);
    this.set("state", data.dataFieldTable.state);
    this.set("incidentType", data.dataFieldTable.incidentType);
  }

  objectDefinition() {
    return IncidentAspect._objectDefinition();
  }

  createStyle() {
    let state = this.get("state") ? this.get("state") : "OFF";
    state = "incident";
    return [
      new ol.style.Style({
        image: new ol.style.Icon({
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: this.getImagePath("INCIDENT/", state),
          anchor: [0.5, 0.5]
        })
      })
    ];
  }

  leftClick(pixel, gps) {
    // let boxConfig = {
    //   type: 'edit',
    //   customData: this.getObject(),
    //   parentId: 0,
    //   component: 'IncidentManagerForm',
    //   name: 'Incident ' + this.get('referenceName'),
    //   id: 'IncidentManagerForm' + this.get('referenceName'),
    // }
    // this.$emit('openBoxMgr', boxConfig);
  }

  rightClick(pixel, gps, rightClickBehaviour = 0) {}

  createTooltip() {
    let dt = new Date(this.get("date")).toLocaleString();
    let desc = this.get("description");
    if (this.desc == "") {
      desc = translate("NO_DESC");
    }

    let text = "<div id='map-popup-tooltip'>";
    text += "<p class='pop-up-atribute' >Id: " + this.get("id") + "</p>";
    text += "<p class='pop-up-atribute' >State: " + this.get("state") + "</p>";
    text += "<p class='pop-up-atribute' >Date: " + dt + "</p>";
    text += "<p class='pop-up-atribute' >Description: " + desc + "</p>";
    text += "</div>";
    return text;
  }

  static _objectDefinition() {
    return {
      id: null,
      type: "Incident",
      incidentType: "",
      location: "",
      description: "",
      photo: "",
      decimal: new Array(2),
      date: "",
      state: "",
      photos: [],
      username: "",
      userId: "",
      dataFieldTable: {}
    };
  }

  static _parseIncidentObject(aspect) {
    let object = this._objectDefinition();

    object.id = aspect.id;
    object.description = aspect.description;
    object.incidentType = aspect.incidentType;
    object.date = aspect.date;
    object.state = aspect.state;
    object.username = aspect.dataFieldTable.userName;

    let position = aspect.position;
    let positionTransformed = ol.proj.transform(
      position,
      "EPSG:3857",
      "EPSG:4326"
    );

    object.decimal[0] = positionTransformed[0];
    object.decimal[1] = positionTransformed[1];

    return object;
  }

  static _parseIncidentAspectToObject(aspect) {
    let object = this._objectDefinition();

    object.id = aspect.get("id");
    object.description = aspect.get("description");
    object.incidentType = aspect.get("incidentType");
    object.date = aspect.get("date");
    object.state = aspect.get("state");

    let position = aspect.get("geometry");
    let positionTransformed = ol.proj.transform(
      position,
      "EPSG:3857",
      "EPSG:4326"
    );

    object.decimal[0] = positionTransformed[0];
    object.decimal[1] = positionTransformed[1];

    return object;
  }

  static _parseIncidentDataToObject(incident) {
    let object = this._objectDefinition();

    if (incident.hasOwnProperty("id")) {
      object.id = incident.id;
    }
    if (incident.hasOwnProperty("description")) {
      object.description = incident.description;
    }

    return object;
  }

  static _createRequestObjectNew(object, customData) {
    let req = {
      UserName: object.userName,
      // UserId: object.userId,
      Id: object.id,
      Type: object.type,
      IncidentType: object.incidentType,
      Description: object.description,
      UserName: object.userName,
      State: customData.dataFieldTable.state,
      Latitude: customData.latitude,
      Longitude: customData.longitude
    };
    return req;
  }

  static _createRequestObject2(object) {
    let requestObject = {
      Type: "Incident",
      Latitude: object.decimal[1],
      Longitude: object.decimal[0],
      Id: "Incident_" + new Date().getTime(),
      Name: "Incident_" + new Date().getTime(),
      Distance: 0,
      SegmentId: "",
      DataFieldTable: {
        DateTime: new Date().getTime(),
        Description: object.description,
        State: object.state,
        UserName: object.username,
        IncidentType: object.incidentType
      }
    };

    return requestObject;
  }
  static _createRequestObject3(object) {
    let requestObject = {
      Id: object.id,
      Description: object.description,
      IncidentType: object.incidentType,
      State: object.state
    };

    return requestObject;
  }
  static _createAttachmentRequestObject(object) {
    let requestObject = {
      id: object.id,
      AttachmentType: "photos",
      content: object.photo
    };

    return requestObject;
  }

  static _getIncidentDataRequest(id) {
    let requestObject = {
      id: id
    };

    return requestObject;
  }

  static _fillForm(data, form) {
    if (data.hasOwnProperty("IncidentType")) {
      form.incidentType = data.IncidentType.value;
    }
    if (data.hasOwnProperty("description")) {
      form.description = data.description.value;
    }
    if (data.hasOwnProperty("lifeThreat")) {
      form.lifeThreat = data.lifeThreat.value;
    }
    if (data.hasOwnProperty("situation")) {
      form.situation = data.situation.value;
    }
    if (data.hasOwnProperty("location")) {
      form.location = data.location.value;
    }
    if (data.hasOwnProperty("roadId")) {
      form.roadId = data.roadId.value;
    }
    if (data.hasOwnProperty("adress")) {
      form.adress = data.adress.value;
    }
    if (data.hasOwnProperty("number")) {
      form.number = data.number.value;
    }
    if (data.hasOwnProperty("countryCode")) {
      form.countryCode = data.countryCode.value;
    }
    if (data.hasOwnProperty("exactLocation")) {
      form.exactLocation = data.exactLocation.value;
    }
    if (data.hasOwnProperty("photo")) {
      form.photo = data.photo.value;
    }
  }
}
